import { Api } from "@/api";
import { WebUser } from "@prisma/client";
import { LoaderFunctionArgs } from "react-router-dom";

export const PAGE_SIZE = 20;

export type CustomerRow = Pick<
  WebUser,
  | "id"
  | "createdAt"
  | "updatedAt"
  | "uid"
  | "guid"
  | "email"
  | "firstName"
  | "lastName"
  | "verified"
  | "isAdmin"
  | "taxExempt"
>;

export type CustomersData = {
  users: CustomerRow[];
  count: number;
  page: number;
};

// 2026-09-04: one server call (/api/users/list) does filter + search + paging
// in the DB. The old loader called the users CRUD getAll with no page size,
// which returned EVERY WebUser (guests included) with full Stytch blobs, then
// hid unregistered rows client-side — slow loads and timeouts. Filter and
// search live in the URL so page 2 of a search is a real page 2.
export default function dashboardCustomersLoader({
  request,
}: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const page = parseInt(url.searchParams.get("page") || "1", 10);
  const search = url.searchParams.get("search") || "";
  // "Hide unregistered" is ON by default (as before); `all=1` shows guests.
  const registered = url.searchParams.get("all") !== "1";

  const data: Promise<CustomersData> = Api.get<{
    users: CustomerRow[];
    count: number;
    page: number;
  }>("/api/users/list", {
    params: {
      page,
      pageSize: PAGE_SIZE,
      search: search || undefined,
      registered: registered ? "1" : undefined,
    },
  }).then(({ data: res }) => ({
    users: res.users || [],
    count: res.count || 0,
    page: res.page || page,
  }));

  return { data };
}
